import useGetEmails from './useGetEmails'
export default useGetEmails
